import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "utils/useDidMountEffect";
import {isEmpty, isNil} from "lodash";
import apiUser from "apiUser";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import SearchInput from "../../../componentsReusable/AppTable/SearchInput";
import {Alert} from "reactstrap";
import appUserRoutes from "../../../appUserRoutes";
import {TAB_MODULES} from "../../../views/UserViews/TecRmi/MainView";
import Breadcrumb from "../../Breadcrumb";
import {getByModuleId, MODULE_COMFORT_WIRING} from "../Modules";
import ComfortWiringManual from "./ComfortWiringManual";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import TreeMenuNew from "../../../componentsReusable/TreeMenuNew/TreeMenuNew";
import PrintButton from "../PrintButton";

const ComfortWiring = props => {
  const { getApiPrimaryParams, ident } = useTecRmi()
  const [crumbs, setCrumbs] = useState([])
  const [textSearch, setTextSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [comfortWiring, setComfortWiring] = useState([])

  useDidMountEffect(() => {
    fetchData()
  })

  useAfterUpdateEffect(() => {
    setCrumbs([])
    fetchData()
  }, [textSearch])

  const fetchData = () => {
    setLoading(true)
    setComfortWiring([])

    getApiFn()({
      ...getApiPrimaryParams(),
      componentSubgroupId: props?.componentSubgroupId ?? null,
      textSearch,
    })
      .then(res => {
        setComfortWiring(res.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getApiFn = () => {
    if(props.componentSubgroupId){
      return apiUser.tecRmi.comfortWiring.componentList
    }else{
      return apiUser.tecRmi.comfortWiring.list
    }
  }

  const getPath = (params = []) => {
    if(props.disableRoutes){
      return null
    }

    if(!isNil(props.pathPrefix)){
      return props.pathPrefix + params.join('/')
    }

    return appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_COMFORT_WIRING, 'uriName')) + params.join('/')
  }

  const getPathHome = () => {
    return props?.pathHome ?? appUserRoutes.tecRmi.tab(ident, TAB_MODULES)
  }

  const getMappedItems = () => {
    return comfortWiring.map(comfortWiring => ({
      key: `mainGroup-${comfortWiring.MainGroupId}`,
      id: comfortWiring.MainGroupId,
      label: comfortWiring.MainGroupName,
      path: getPath([comfortWiring.MainGroupId]),
      items: comfortWiring.SubGroups.map(subGroup => ({
        key: `subGroup-${subGroup.SubGroupId}`,
        id: subGroup.SubGroupId,
        label: subGroup.SubGroupName,
        path: getPath([comfortWiring.MainGroupId, subGroup.SubGroupId]),
        items: subGroup.ItemMps.map(itemMp => ({
            key: `itemMp-${itemMp.ItemMpId}`,
            id: itemMp.ItemMpId,
            label: itemMp.ItemMpText,
            path: getPath([comfortWiring.MainGroupId, subGroup.SubGroupId, itemMp.ItemMpId]),
            items: itemMp.Manuals.map(manual => ({
              key: `manual-${manual.QualColId}`,
              id: manual.QualColId,
              label: manual.QualColText,
              path: getPath([comfortWiring.MainGroupId, subGroup.SubGroupId, itemMp.ItemMpId, manual.QualColId]),
              component: ComfortWiringManual,
              componentProps: {
                manualId: manual.ManualId,
              }
            }))
          }
        ))
      }))
    }))
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <Breadcrumb
          crumbs={[
            {
              name: <i className="fas fa-chevron-circle-left" />,
              path: getPathHome()
            },
            {
              name: getByModuleId(MODULE_COMFORT_WIRING, 'name'),
              path: getPath(),
            },
            ...crumbs
          ]}
        />

        <div className="d-flex flex-row flex-nowrap justify-content-end ml-auto">
          <PrintButton />
          <SearchInput
            onInputChanged={setTextSearch}
          />
        </div>
      </div>

      <div className="mt-2">
        {loading
          ? <LoadingSpinner/>
          : (
            isEmpty(comfortWiring)
              ? <Alert color={'warning'} className="text-center">Brak danych</Alert>
              : <TreeMenuNew
                actives={props.params}
                  items={getMappedItems()}
                  onCrumbsChanged={setCrumbs}
                />
          )
        }
      </div>
    </div>
  );
};

ComfortWiring.defaultProps = {
  params: [],
  disableRoutes: false,
};

ComfortWiring.propTypes = {
  pathHome: PropTypes.string,
  disableRoutes: PropTypes.bool,
  pathPrefix: PropTypes.string,
  componentSubgroupId: PropTypes.number,
  mainGroupId: PropTypes.number,
};

export default ComfortWiring;